import { render } from "./ResourceFilterForm.vue?vue&type=template&id=572ffa41&ts=true"
import script from "./ResourceFilterForm.vue?vue&type=script&lang=ts"
export * from "./ResourceFilterForm.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__